module.exports = __webpack_public_path__ + "static/media/sunrise2.391ddf45.png";